<template>
  <div style="height: 50%">
    <boxTitleMoudle
      style="color: #529aff; height: 100%"
      class="flex_div green"
      :title="'绿色施工'"
      :left="'0px'"
    >
      <div style="height: 48%">
        <div class="env">
          <section style="height: 35%">
            <img class="title" src="./img/env.png" alt="" />
          </section>
          <section style="width: 100%; height: 60%">
            <div style="padding-left: 30px">未来三天气象</div>
            <div class="flex_bet" style="padding-left: 30px; height: 100%">
              <div style="width: 25%">
                <div
                  class="flex_bet text-center"
                  v-for="(item, index) in weatherListdata"
                  :key="index"
                >
                  <div>{{ index + 1 }}</div>
                  <div style="width: 24px; height: 10%">
                    <img :src="item.url" alt />
                  </div>
                  <div style="font-size: 12px">
                    <p>{{ item.description }}</p>
                    <p>{{ item.temperature }}</p>
                  </div>
                </div>
                <!-- <div class="flex_bet text-center">
                <div>2</div>
                <div style="width: 24px; height: 22px">
                  <img src="./img/sunny.png" alt />
                </div>
                <div style="font-size: 12px">
                  <p>晴转多云</p>
                  <p>12℃~21℃</p>
                </div>
              </div>
              <div class="flex_bet text-center">
                <div>3</div>
                <div style="width: 24px; height: 22px">
                  <img src="./img/rain.png" alt />
                </div>
                <div style="font-size: 12px">
                  <p>小雨</p>
                  <p>12℃~21℃</p>
                </div>
              </div> -->
              </div>
              <div style="width: 75%; height: 100%; position: relative">
                <p
                  style="
                    position: absolute;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    padding: 0 10px;
                  "
                >
                  <span
                    v-for="(item, index) in envData"
                    :key="index"
                    style="
                      flex: 1;
                      text-align: center;
                      color: #fff;
                      margin-right: 6px;
                    "
                    >{{ item.data + item.unit }}
                  </span>
                </p>
                <div id="env_chart" style="width: 100%; height: 100%"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div style="height: 52%">
        <div class="power">
          <section style="height: 35%">
            <span class="f-right1 light">用电·Kw/h</span>
            <span class="f-right1 water">用水·T</span>
            <img class="title" src="./img/power.png" alt="" />
          </section>
          <section style="width: 100%; height: 64%">
            <div id="power_chart" style="width: 100%; height: 100%"></div>
          </section>
        </div>
      </div>
    </boxTitleMoudle>
  </div>
</template>
<script>
import boxTitleMoudle from "@/components/BaseBoxTitleMoudle.vue";
export default {
  data() {
    return {
      weatherListdata: [],
      envData: [],
    };
  },
  components: {
    boxTitleMoudle,
  },
  created() {
    // 天气
    this.deviceWeatherData();
    // 能耗监测
    this.getElectricityStatistical();
    // 温湿度
    this.deviceEnviCurData();
  },
  mounted() {
    this.env_chart();
  },
  methods: {
    // 能耗监测
    getElectricityStatistical() {
      this.$api.getElectricityStatistical().then((res) => {
        if (res.code == "200") {
          if (res.data && res.data.length > 0) {
            this.power_chart(res.data);
          }
        }
      });
    },
    // 天气
    deviceWeatherData() {
      this.$api.deviceWeatherData().then((res) => {
        if (res.code == "200") {
          this.weatherListdata = res.data;
        }
      });
    },
    power_chart(data) {
      // 橙色
      let orgIcon =
        '<svg width="11" height="10" viewBox="0 0 11 10" xmlns="http://www.w3.org/2000/svg"><g transform="translate(.719 .164)" fill="none" fill-rule="evenodd"><circle stroke="#D36218" fill="#323538" cx="4.833" cy="4.833" r="4.333"/><circle fill="#D36218" cx="4.833" cy="4.833" r="1.758"/></g></svg>';
      orgIcon = encodeURIComponent(orgIcon); // 转译
      orgIcon = "data:image/svg+xml;utf8," + orgIcon; // 添加url前缀
      orgIcon = "image://" + orgIcon; // 添加ECharts需要的前缀
      // 蓝色
      let blueIcon =
        '<svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg"><g transform="translate(.719 .564)" fill="none" fill-rule="evenodd"><circle stroke="#57F7FF" fill="#323538" cx="4.833" cy="4.833" r="4.333"/><circle fill="#57F7FF" cx="4.833" cy="4.833" r="1.758"/></g></svg>';
      blueIcon = encodeURIComponent(blueIcon); // 转译
      blueIcon = "data:image/svg+xml;utf8," + blueIcon; // 添加url前缀
      blueIcon = "image://" + blueIcon; // 添加ECharts需要的前缀

      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("power_chart"));
      let powerData = data.splice(0, 6);
      let time = [];
      let water = [];
      let electricity = [];
      powerData.forEach((item) => {
        time.push(item.dateTime);
        water.push(item.water);
        electricity.push(item.electricity);
      });
      let option = {
        tooltip: {
          trigger: "item",
          formatter: function (arg) {
            let html = time[arg["dataIndex"]] + "<br>";
            html += "用水量:" + water[arg["dataIndex"]] + "t<br>";
            html += "用电量:" + electricity[arg["dataIndex"]] + "kw/h<br>";

            return html;
          },
        },
        xAxis: {
          type: "category",
          data: time,
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.7)",
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.7)",
            },
          },
          splitLine: {
            show: false,
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "4%",
          top: "10%",
          containLabel: true,
        },
        series: [
          {
            data: water,
            type: "line",
            symbol: blueIcon,
            symbolSize: 10,
            label: {
              normal: {
                show: false,
                color: "#FFFFFF",
                position: "top",
              },
            },
            lineStyle: {
              normal: {
                color: "#57f7ff",
                width: 1,
                type: "dashed",
              },
            },
            smooth: true,
          },
          {
            data: electricity,
            type: "line",
            symbolSize: 10,
            symbol: orgIcon,
            label: {
              normal: {
                show: false,
                color: "#FFFFFF",
                position: "top",
              },
            },
            lineStyle: {
              normal: {
                color: "rgba(211,98,24,1)",
                width: 1,
                type: "dashed",
              },
            },
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    env_chart(data, unit) {
      console.log(unit, "unit");
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("env_chart"));
      var dataAxis = ["温度", "风湿", "噪音", "风向", "PM2.5", "PM10"];
      // let data = [
      //   Math.floor(Math.random() * (100 - 200) + 200),
      //   Math.floor(Math.random() * (70 - 80) + 80),
      //   Math.floor(Math.random() * (90 - 100) + 100),
      //   Math.floor(Math.random() * (100 - 170) + 170),
      //   Math.floor(Math.random() * (50 - 60) + 60),
      //   Math.floor(Math.random() * (200 - 220) + 220),
      // ];
      // let yMax = 800;
      // let dataShadow = [];
      // for (let i = 0; i < data.length; i++) {
      //   dataShadow.push(yMax);
      // }

      let option = {
        xAxis: {
          data: dataAxis,
          axisLabel: {
            textStyle: {
              show: true,
              color: "#fff",
              interval: 0,
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        grid: {
          left: "-1%",
          right: "4%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
          show: false,
        },

        series: [
          {
            data: data,
            type: "bar",
            showBackground: true,
            barWidth: "24px",

            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = [
                    "rgba(254,66,65,1)",
                    "rgba(83,164,102,1)",
                    "rgba(3,117,255,1)",
                    "rgba(3,117,255,1)",
                  ];
                  return colorList[params.dataIndex];
                },
                label: {
                  show: false,
                  textStyle: {
                    fontWeight: "bolder",
                    fontSize: "12",
                    fontFamily: "微软雅黑",
                    color: "#fff",
                  },
                  formatter: function (params) {
                    let text = unit;
                    return params.value + text[params.dataIndex];
                  },
                  position: "top",
                },
              },
            },

            backgroundStyle: {
              color: {
                type: "linear",
                x: 0, // 左上角x
                y: 0, // 左上角y
                x2: 0, // 右下角x
                y2: 1, // 右下角y
                colorStops: [
                  {
                    offset: 0,
                    color: "#FFFFFF", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#343434", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    // 温湿度
    deviceEnviCurData() {
      this.$api.deviceEnviCurData().then((res) => {
        if (res.code == "200") {
          if (res.data) {
            let data = [
              res.data && res.data.temperature,
              res.data && res.data.humidity,
              res.data && res.data.noise,
              res.data && res.data.speed,
              res.data && res.data.pmtwo,
              res.data && res.data.pmten,
            ];
            let unit = [
              res.data && res.data.temperatureUnit,
              res.data && res.data.humidityUnit,
              res.data && res.data.noiseUnit,
              res.data && res.data.speedUnit,
              res.data && res.data.pmtwoUnit,
              res.data && res.data.pmtenUnit,
            ];
            this.envData = [
              {
                data: res.data && res.data.temperature,
                unit: res.data && res.data.temperatureUnit,
              },
              {
                data: res.data && res.data.humidity,
                unit: res.data && res.data.humidityUnit,
              },
              {
                data: res.data && res.data.noise,
                unit: res.data && res.data.noiseUnit,
              },
              {
                data: res.data && res.data.speed,
                unit: res.data && res.data.speedUnit,
              },
              {
                data: res.data && res.data.pmtwo,
                unit: res.data && res.data.pmtwoUnit,
              },
              {
                data: res.data && res.data.pmten,
                unit: res.data && res.data.pmtenUnit,
              },
            ];
            this.env_chart(data, unit);
          } else {
            let data = [0, 0, 0, 0, 0, 0];
            let unit = ["暂无", "暂无", "暂无", "暂无", "暂无", "暂无"];
            this.envData = [
              {
                data: "",
                unit: "暂无",
              },
              {
                data: "",
                unit: "暂无",
              },
              {
                data: "",
                unit: "暂无",
              },
              {
                data: "",
                unit: "暂无",
              },
              {
                data: "",
                unit: "暂无",
              },
              {
                data: "",
                unit: "暂无",
              },
            ];
            this.env_chart(data, unit);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex_div {
  width: 100%;

  height: 50%;
}
</style>